// import "./TFDAccelerateInternationalExperience.css";
import "./AccelerateGlobal.css";

import { Link } from "react-router-dom";
import React from "react";

export default function TFDAccelerateInternationalExperience() {
  return (
    <div className="tfd-accelerate-international-experience-page">
      {/* HERO SECTION */}
      <section className="tf-hero-international-experience">
        <div className="hero-image-wrap">
          <img
            src="/images/accelerate/international-experience-hero.jpg"
            alt="International Experience Hero"
            className="hero-bg-image"
          />
          <div className="overlay-dark" />
          <div className="hero-content themeflat-container">
            <h1 className="hero-title wow fadeInUp animated">
              TFD ACCELERATE International Experience
            </h1>
            <p className="hero-subtitle wow fadeInUp animated">
              Unlock global opportunities and refine your game with world-class coaching.
            </p>
            <Link to="/contact" className="flat-button wow fadeInUp animated">
              Discover More
            </Link>
          </div>
        </div>
      </section>

      {/* INFO SECTION */}
      <section className="tf-international-experience-info main-content">
        <div className="themeflat-container">
          <div className="row align-items-center">
            {/* Text Column */}
            <div className="col-md-6 wow fadeInLeft animated">
              <div className="title-box title-small-v2">
                <span className="sub-title">Global Exposure</span>
                <h2 className="title-section">
                  Train with International Experts
                </h2>
              </div>
              <p className="post">
                Our International Experience program connects you with elite training facilities and coaches from around the world. Enhance your technical, tactical, and mental skills while experiencing diverse football cultures.
              </p>
              <ul className="list-check">
                <li>
                  <strong>World-Class Coaching:</strong> Learn from international experts.
                </li>
                <li>
                  <strong>Cultural Exchange:</strong> Discover new football philosophies.
                </li>
                <li>
                  <strong>Global Competitions:</strong> Showcase your talent on a worldwide stage.
                </li>
                <li>
                  <strong>Advanced Techniques:</strong> Stay ahead with cutting-edge training.
                </li>
              </ul>
              <Link to="/contact" className="flat-button mt-3">
                Apply Now
              </Link>
            </div>
            {/* Image Column */}
            <div className="col-md-6 wow fadeInRight animated">
              <div className="image-wrapper">
                <img
                  src="/images/accelerate/international-experience-info.jpg"
                  alt="International Training Session"
                  className="image-gr"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="tf-international-experience-cta main-content">
        <div className="themeflat-container text-center">
          <Link
            to="/contact"
            className="flat-button big-cta-button wow fadeInUp animated"
          >
            Join the Global Experience
          </Link>
        </div>
      </section>
    </div>
  );
}
